<template>
	<div class="inventory_Wrapper">
		<div   class="IdScaneArea">
			<el-input
			 size="mini"
			  v-model="productCoding"
			   :placeholder="$t('other.a2699')"
			  @change="scanProductCoding()"
			  >
			</el-input>
		</div>
		<div class="ppo_box">
			
			<div class="titl_desc_left">
				<div class="ppo-item">{{$t('other.a1866')}}:{{orderParam.userId}}</div>
                <div class="ppo-item">{{$t('other.a2700')}}{{orderParam.P_num}}{{$t('other.a2701')}}</div>
                <div class="ppo-item">{{$t('other.a2700')}}{{orderParam.num}}{{$t('other.a2615')}}</div>
				<div class="ppo-item">{{$t('other.a2702')}}：{{actualPicklist}}</div>
				<div class="ppo-item">{{$t('other.a2703')}}：{{totalPicklist}}</div>
			</div>
			<div class="titl_desc_right">
				<div style="margin:0 20px" v-if="record"><el-button  size="medium" type="danger" @click="tableList = recordData">{{record}}</el-button></div>
				<div><el-button size="medium" type="primary" @click="saveRecore()">{{$t('other.a2704')}}</el-button></div>
				<div style="margin:0 20px" v-if="!targetItem.transferTime"><el-button size="medium" type="primary" @click="outProduct()">{{$t('other.a2705')}}，{{$t('other.a2742')}}</el-button></div>
				<div style="margin:0 20px" v-if="targetItem.transferTime"><el-button size="medium" type="primary" @click="newStoreComfirm()">{{$t('other.a2705')}}</el-button></div>
			</div>
			
		</div>
		  <el-table ref="multipleTable" :data="tableList"  tooltip-effect="dark" 
		 
          :row-class-name="tableRowClassName"
          border style="width: 100%;margin-bottom: 50px;" select-all="checkedall"
		   @selection-change="handleSelectionChange">
			<el-table-column label="Product(s)" width="100">
				<template slot-scope="scope">
					<span ><img :src="scope.row.image" /></span>
				</template>
			</el-table-column>
			<el-table-column prop="address" :label="$t('other.a2706')" show-overflow-tooltip>
				<template slot-scope="scope">
					<div  class="orderInfo" >
                        <div class="bvmt">{{scope.row.cusCode}}({{scope.row.encoding ? scope.row.encoding : $t('other.a887')}})</div>
                    </div>
				</template>
			</el-table-column>
			<el-table-column prop="skuName" label="SKU" show-overflow-tooltip>
				<template slot-scope="scope">
					<div  class="orderInfo" >
                        <div class="bvmt sbti">{{scope.row.skuName ? scope.row.skuName :$t('other.a260')}}</div>
                    </div>
				</template>
			</el-table-column>
            <el-table-column prop="storeNum" :label="$t('other.a2707')"  show-overflow-tooltip>
				<template slot-scope="scope">
					<div  class="orderInfo" >
                        <div class="bvmt sbti">{{scope.row.storeNum}}</div>
                    </div>
				</template>
			</el-table-column>
			<el-table-column prop="address" :label="$t('other.a2708')"  show-overflow-tooltip>
				<template slot-scope="scope">
					<div  class="orderInfo" >
                        <div class="bvmt  ">
							 <el-input-number class="vkhjkf" size="mini" v-model="scope.row.pickingNum"  :min="0"></el-input-number>
							 <i v-show="scope.row.pickingNum == scope.row.storeNum" class="iconfont icon-gouxuanxuanzhongtai"></i>
							 <i v-show="scope.row.pickingNum > scope.row.storeNum" class="iconfont icon-jinggao1"></i>
						</div>
                    </div>
				</template>
			</el-table-column>
		  </el-table>
	</div>
</template>

<script>
		import {mapState, mapActions , mapMutations} from 'vuex'
        import newOrder from '../../api/moudles/newOrders'
		import transfer from '../../api/moudles/transfer'
		import api from '../../api/api'
		import utils from '../../utils/utils.js'
        import userStoreItems  from '../../api/moudles/userStoreItems'
import jsonp from '../../api/jsonp'
	export default{
		data(){
			return {
				tableList:[],
				shopInfo:null,
				orders:{},
				textarea:'',
				returntextarea:null,
				scanNum:'',
				diaReturnOrder:false,
				packTime:null,
				shopee:null,
				productCoding:'',
				record:'',
				recordData:null,
                processedList:[],
                orderParam:{
                    actualNum:0,
                    orderId:this.$t("other.a354"),
                    userId:this.$t("other.a354"),
                    totalPurchase:0,
                    num:0,
                    P_num:0
                }
			}
		},
		computed:{
			
			...mapState({
				userId: state=>state.login.userInfo.userId || '',
			}),

			totalPicklist(){
				let list=0
				this.tableList.forEach(p => {
					list+=p.pickingNum
				})

				return list
			},

			actualPicklist(){
				let list=0
				this.tableList.forEach(p => {
                        p.storeNum=p.storeNum > 0 ? p.storeNum : 0
						list+=p.storeNum
				})

				return list
			},
		
		},
		watch:{
			diaReturnOrder(){
				if(!this.diaReturnOrder){
					this.returntextarea=null
				}
			}
		},
		created(){
			this.hfkf()
			this.draftbox()
		},
		methods:{
			...mapActions('processed',[
				'getProcessedOrderSn',
				'getProcessedOrderInfo',
				'getIDacountProcessedList',
				'getPackagedOrderByStore',//仓库帐号下猎取已出库出库的订单
				'setPackaged',
				'setPackagedCopy',
				'getProcessedOrders',
				'getLogisticsBystore',
				'getLogisticsByseller',
				'getProcessedOrderBySeller',
				'getProcessedOrderByStore'
			]),


             tableRowClassName({row, rowIndex}) {
                if (rowIndex === 0) {
                return 'warning-row';
                } 
                return '';
            },

			returnOrder(){
				if(!this.returntextarea){
					this.$message.warning(this.$t('other.a2709'))
					return
				}

				if(!this.orderParam.orderId){
					this.$message.warning(this.$t('other.a2710'))
					return
				}
				this.orders.msg=this.returntextarea

				newOrder
				.cancelAuditedOrders([this.orders])
				.then(res => {
					if(res.code === 200) {
						this.$message.success('Successfully returned review')
						this.diaReturnOrder=false
						this.resetOrder()
					}else{
						this.$message.warning(res.msg)
					}
				})
			},

			draftbox(){
				let params={
					cacheData:JSON.stringify(this.tableList),
					cacheKey:this.targetItem.items > 0 ? this.targetItem.newStoreId+'_'+this.targetItem.transferId :  this.targetItem.oldStoreId+'_'+this.targetItem.transferId,
					userId:this.userId
				}
				api
				.getUserCache(params)
				.then(res => {
				if(res.code === 200 ){
				console.log('desc',res.data)
				let ttp=null
				if(res.data){

					ttp= JSON.parse(res.data.cacheData)
					let list=ttp.filter(p => {
						if(p !== null){
							return p
						}
					})
					console.log('ttp',list)
					this.recordData=list
					this.record=this.$t('other.a2711')+utils.renderTime(res.data.updateTime)+this.$t('other.a2712')
					console.log(this.record)
				}else{
					ttp=null
				}
				
				}else{
				this.$message.warning(res.msg)
				}
				})
			},
			// 保存当前纪录
			saveRecore(){
				console.log(this.targetItem)
				let params={
					cacheData:JSON.stringify(this.tableList),
					cacheKey:this.targetItem.items > 0 ? this.targetItem.newStoreId+'_'+this.targetItem.transferId :  this.targetItem.oldStoreId+'_'+this.targetItem.transferId,
					userId:this.userId
				}

				this.$confirm(this.$t('other.a2743'), this.$t("other.a142"), {
				confirmButtonText: this.$t('other.a235'),
				cancelButtonText: this.$t('other.a146'),
				type: 'warning'
				}).then(() => {

					api
					.setUserCache(params)
					.then(res => {
					if(res.code === 200 ){
					console.log('desc',res.data)
					this.$message.success(this.$t('other.a993'))
					this.draftbox()
					}else{
					this.$message.warning(res.msg)
					}
					})
	
					console.log(params)
				})
			},

			outProduct(){
				this.targetItem.userId=this.userId
				this.targetItem.sellerConfirmTime=null
				this.targetItem.createTime=null
				this.targetItem.items=this.tableList.map(p => {
					return {
						cusCode:p.cusCode,
						oldQuantity:p.pickingNum,
					}
				})
				console.log(this.targetItem)
				let text=this.$t('other.a2744')
				this.$confirm(text, this.$t("other.a142"), {
				confirmButtonText: this.$t('other.a235'),
				cancelButtonText: this.$t('other.a146'),
				type: 'warning'
				}).then(() => {
				transfer
                .checkOldProduct(this.targetItem)
                .then(res => {
                    if(res.code === 200) {
						this.$message.success(this.$t('other.a2745'))
						this.$router.push('/transfer')
                    }else{
                        this.$message.warning(res.msg)
                    }
                })
				})
			},
			//新仓盘点入库
			newStoreComfirm(){
				let obj=JSON.parse(JSON.stringify(this.targetItem))
				obj.userId=this.userId
				obj.sellerConfirmTime=null
				obj.transferTime=null
				obj.createTime=null
				obj.items=this.tableList.map(p => {
					return {
						cusCode:p.cusCode,
						newQuantity:p.pickingNum,
						barn:true
					}
				})
				console.log(obj)
				let text=this.$t('other.a2746')
				this.$confirm(text, this.$t("other.a142"), {
				confirmButtonText: this.$t('other.a235'),
				cancelButtonText: this.$t('other.a146'),
				type: 'warning'
				}).then(() => {
				transfer
                .newStoreCheckProduct(obj)
                .then(res => {
                    if(res.code === 200) {
						this.$message.success(this.$t('other.a2747'))
						this.$router.push('/transfer')
                    }else{
                        this.$message.warning(res.msg)
                    }
                })
				})
			},

			resetOrder(){
				this.tableList=[]
				this.orderParam={
                    actualNum:0,
                    orderId:this.$t("other.a354"),
                    userId:this.$t("other.a354"),
                    totalPurchase:0
                }
			},
			
			reset(){
				this.tableList.forEach(p => {
					p.children.forEach(k => {
						k.pickingNum=0
					})
				})
			},

			match(name,key){
				let ttp=JSON.parse(JSON.stringify(name))
				let ccp=JSON.parse(JSON.stringify(key))
				if(name){
					let flag=false
					if(ttp.replace(/\s*/g,"") == ccp.replace(/\s*/g,"")){
						console.log(ttp)
						console.log(ccp)
						flag= true
					}else{
						flag= false
					}

					return flag
				}else{
					return false
				}

				
			},

			//产品条形码扫描
			scanProductCoding(){
				
				this.productCoding=this.productCoding.trim()
				// this.tableList=null
                let num=0
                let oop=null
				let obj=null
				this.tableList.forEach((item,index) => {
					if(item){
						item.skuName=item.skuName
						if(item.cusCode == this.productCoding || item.encoding == this.productCoding ||  this.match(item.skuName,this.productCoding) ){
							num=index
							obj=item
							oop=item
						}
					}


					
				})
				
               

                if(obj){
                    obj.pickingNum++
                    console.log('obj',obj)
					this.tableList.splice(num,1)
					this.tableList.unshift(oop)
                    
                    setTimeout(() => {
                        this.productCoding=''
                    },200)

                }else{
                    this.$message.warning(this.$t('other.a2718'))
                    this.productCoding=''
					
                }

				console.log(this.tableList)
                    

			},

			packBageOutCopy(){
				this.scanNum=this.scanNum.replace(/\s*/g,"")
				if(this.scanNum){
					this.tableList=[]
                    this.orderParam.totalPurchase=0
                    newOrder
                    .getOrderInfoByScan({
						orderId:this.scanNum,
						userId:this.userId,
						storeIds:JSON.parse(localStorage.getItem('userInfo')).storeIds
					})
                    .then(res => {
                        if(res.code === 200) {
							let  mapList=new Map()
							console.log(res.data)
                            this.orderParam.orderId=res.data.orderId
                            this.orderParam.logistics=res.data.logistics
                            this.orderParam.userId=res.data.userId

							this.orders.orderId=res.data.orderId
							this.orders.shopId=res.data.shopId
							this.orders.storeId=res.data.storeId
							this.orders.userId=this.userId

				


							res.data.items.forEach(k => {
								let list=[]
								
								if(k.storeItem){
									list=mapList.get(k.storeItem.cusCode)

									if(!list || list == undefined || list == null){
										list=[]
									}

									list.push(k)
									mapList.set(k.storeItem.cusCode,list)
								}else{
									this.$confirm('The current order does not bind the stock product, please return the audit and inform the seller to make a binding relationship, then review to the warehouse processing!', 'Prompt', {
									confirmButtonText: 'retrunToSeller',
									cancelButtonText: 'cancel',
									type: 'warning'
									}).then(() => {
										this.diaReturnOrder=true
									})
									
									return
								}
							})

							let list2=[]

							mapList.forEach((value,key) => {
								console.log(value,key)
								let arr=JSON.parse(JSON.stringify(value[0]))
								arr.variationQuantityPurchased=0
								value.forEach(item => {
									arr.variationQuantityPurchased += item.variationQuantityPurchased
								})
								list2.push(arr)
							}) 

							 console.log('mapList',mapList)
							 console.log('list2',list2)


							
                            list2.forEach(p => {
								let obj=new Object()
								obj.children=[]
								obj.image=p.image
								
								if(p.itemKey === 'DXS|EMPTY_ORDER'){
									p.storeItem={}
									p.storeItem.purcahseQty=0
									obj.children.push({
												cusCode:'Empty Gift',
												encoding:'Empty Gift',
												sku:'Empty Gift',
												purcahseQty:'Empty Gift',
												pickingNum:'Empty Gift',
											})  
									this.tableList.push(obj)
								}else{

									p.storeItem.purcahseQty=p.variationQuantityPurchased
									
									if(p.storeItem && !p.storeItem.component && p.storeItem.children){//套餐
										obj.component=false,
										p.storeItem.children.forEach(i => {
											i.purcahseQty=p.variationQuantityPurchased
											obj.children.push({
												cusCode:i.cusCode,
												encoding:i.encoding,
												sku:i.skuName,
												purcahseQty:Number(i.purcahseQty) * i.rate,
												pickingNum:0
											})  
											
										})
										
									}else{//单品
										obj.component=true,
										obj.children.push({
												cusCode:p.storeItem.cusCode,
												encoding:p.storeItem.encoding,
												sku:p.storeItem.skuName,
												purcahseQty:p.storeItem.purcahseQty,
												pickingNum:0
										})
									   
									}
									this.tableList.push(obj)
								}
                            })
                        
							console.log('tableList',this.tableList)
                           

                            setTimeout(() => {
                                this.scanNum=''
                            },200)
                                
                        }else{
                            this.$message.warning(res.msg)
                        }
                    })	
				}else{
					
					return
				}
			},

			
			//扫描枪调用的方法
			packBageOut(){
				if(this.scanNum){
					if(this.shopee){
						this.setPackaged({orderId:this.scanNum})
						setTimeout(() => {
							this.scanNum=''
						},200)
					}else{
						this.setPackaged({orderId:this.scanNum})
						setTimeout(() => {
							this.scanNum=''
						},200)
					}
					
				}else{
					
					return
				}
			},
			hfkf(){
				this.targetItem=JSON.parse(this.$route.query.obj)
                this.orderParam.userId=this.targetItem.sellerId
				let params=null
				if(!this.targetItem.items.length){//旧仓已经盘点完产品
					params={
						targetStoreId:this.targetItem.newStoreId,
						sellerId:this.targetItem.sellerId,
						storeId:this.targetItem.oldStoreId,
						userId:this.userId
					}

				}else{//新仓开始盘点完产品
					params={
						targetStoreId:null,
						sellerId:this.targetItem.sellerId,
						storeId:this.targetItem.newStoreId,
						userId:this.userId
					}
				}
                newOrder
                .getSellerStoreItemData(params)
                .then(res => {
                    if(res.code === 200) {
							console.log('仓库产品的item',res.data.items)
							let list=[]
							this.orderParam.P_num=res.data.items.length
							res.data.items.forEach(p =>  {
									p.pickingNum=0
									p.storeNum=this.targetItem.items.length > 0 ? this.targetItem.items.find(item => item.cusCode == p.cusCode).oldQuantity : p.storeNum
									this.tableList.push(p)
							})
							this.tableList.sort((a,b) => {
								return b.storeNum - a.storeNum
							})
							this.orderParam.num=this.tableList.length
						
                        

                    }else{
                        this.$message.warning(res.msg)
                    }
                })
                

				
			},
			handleSizeChange(val) {
				this.offset=Number(`${val}`)
				console.log(this.offset);
			 },
			handleCurrentChange(val) {
				this.page=this.offset*(Number(`${val}`) -1)
				this.getOrdersn({
					offset:this.offset,
					page:this.page,
					shopIds:this.shopIdlist,
					storeIds:this.warehouse,
				})	
			},
			handleSelectionChange(val) {
				console.log(val)
				if(val.length === this.choseOrderList.length || val.length === this.orderList2.length){
					this.chooseAll=true
				}else{
					this.chooseAll=false
				}
				this.multipleSelection = val
				console.log(this.multipleSelection)
			
			},
		}
			
	}
</script>

<style>

	
	.inventory_Wrapper {
		position:absolute;
		width:100%;
		box-sizing:border-box;
		padding:0 20px;
		margin-top:20px;
	}

	.inventory_Wrapper .sbti{
		font-size: 25px;
		color: red;
		font-weight: bold;

	}

	

	.inventory_Wrapper .sbtiCopy{
		font-size: 25px;
		color: rgb(0, 199, 163);
		font-weight: bold;

	}

	

    .inventory_Wrapper .orderInfo{
        font-size: 18px;
    }

    .inventory_Wrapper .bvmt{
        margin: 20px 0;
    }

    .inventory_Wrapper .orderInfo_item{
        margin: 0 10px;
    }
	
	.inventory_Wrapper .order-list-item {
		position: relative;
		padding-bottom: 10px;
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
	}
	
	.inventory_Wrapper .order-title {
	
		border-bottom: 1px #E0E0E0 solid;
	}
	
	.inventory_Wrapper .order-title-count {
		color: red;
		font-style: inherit;
		margin-left: 10px;
	}
	
	.inventory_Wrapper .order-query {
		display: flex;
		justify-content: start;
		align-items: center;
		padding: 10px;
		border-bottom: 1px #E0E0E0 solid;
	}
	
	.el-tooltip__popper.is-dark{
		background: #000000!important;
	}
	
	
	
	.inventory_Wrapper .order-query .query {
		position: relative;
		margin-right: 30px;
	}
	
	.inventory_Wrapper .list-btn {
		padding: 20px 15px;
	}
	
	.inventory_Wrapper .list-desc {
		margin-left: 15px;
		border-bottom: 1px #eee solid;
	}
	
	.inventory_Wrapper .list-desc-item {
		font-size: 14px;
	
		padding-right: 15px;
	}
	
	.icon-box {
	    width: 22px; height: 22px; cursor: pointer; display: inline-block;
	}
	 .icon-box.svg-box:hover {
	     color: tomato;
	 }
	
	.inventory_Wrapper .list-item-status {
		color: red;
	}
	
	.inventory_Wrapper .didan {
		font-size: 24px;
	}
	
	.inventory_Wrapper .list-content {
		display: flex;
		justify-content: space-around;
		/* margin: 20px;
	padding: 20px; */
		/* box-shadow: 0 2px 12px 0 rgba(0,0,0,.1); */
	}
	
	.inventory_Wrapper .order-pic {
		width: 80px;
		height: 80px;
	}
	
	img {
		width: 100%;
	}
	
	.inventory_Wrapper .list-content-left,
	.list-content-right {
		display: flex;
	
	}
	
	.inventory_Wrapper .list-item-wrapper {
		box-sizing: border-box;
		padding: 15px;
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
	}
	
	.inventory_Wrapper .order-selec {
		width: 150px;
		margin: 0 10px;
	}
	
	.inventory_Wrapper .block-ttp {
		width: 350px !important;
	}
	
	.inventory_Wrapper .order-desc {
		width: 30%;
	}
	
	.inventory_Wrapper .order-title-desc {
		margin-bottom: 15px;
	}
	
	.stroeVisble .el-input__inner{
		width: 99%;
		height: 130px;
		font-size: 30px
	}
	
	.inventory_Wrapper .list-price-item,
	.shoper-name {
		padding: 2px 0;
	}
	
	.inventory_Wrapper .list-number,
	.list-price {
		margin-left: 40px;
	}
	
	.list-price-btn {
		display: flex;
		flex-direction: column;
	}
	
	.list-price-btn-item {
		margin-top: 20px;
		margin-left: 0 !important;
		width: 120px;
	}
	
	.inventory_Wrapper .primary-btn {
		display: inline-block;
		margin: 0 30px;
	}
	
	.second-menu-wrapper {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	
	.asb {
		position: relative;
	}
	
	.dialog-wrapper {
		display: flex;
		flex-wrap: wrap;
		position: absolute;
		top: 50px;
		left: -600px;
		bottom: 0;
		right: 0;
		width: 600px;
		background-color: #fff;
		margin: 0 auto;
		z-index: 40;
		box-shadow: 0 0 25px #cac6c6;
	
	}
	
	.dialog-wrapper-item {
		display: inline-block;
		width: 100px;
		height: 100px;
		box-sizing: border-box;
		background-color: #fff;
		padding: 5px;
	}
	
	
	.inventory_Wrapper .second-menu {
		display: flex;
		justify-content: flex-start;
		position: relative;
	
	}
	
	.inventory_Wrapper .menu-right-btn {
		margin-right: 30px;
		color: #606266;
		;
	}
	
	
	.el-icon-loading:before {
	    content: "\E6CF";
	    font-size: 20px;
	}
	
	.notify-boxw{
		width: 330px;
		height: 80px;
		box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
		position: absolute;
		top: 150px;
		right: 30px;
		border-radius: 8px;
		box-sizing: border-box;
		padding: 10px;
		z-index: 999999;
	}
	
	.inventory_Wrapper .second-menu-left {
	
		display: flex;
		;
	
	}
	

	.icon-gouxuanxuanzhongtai{
		color: rgb(0, 199, 163);
		font-size: 25px;
		margin-left: 20px;
	}

	.icon-jinggao1{
		color: rgb(255, 82, 69);
		font-size: 18px;
		margin-left: 20px;
	}
	
	
	.inventory_Wrapper .sousuo-box {
		width: 300px;
		margin-right: 20px;
	}
	
	.inventory_Wrapper .chekbox {
		width: 30px;
		height: 30px;
	}
	
	.inventory_Wrapper .Pager{
		position: fixed;
		bottom: 0;
		left: 235px;
		right: 0;
		height: 40px;
		line-height: 40px;
		background-color: #fff;
		text-align:right;
		
		
	
		
	}
	
	.inventory_Wrapper .el-pagination {
		display: flex;
		justify-content: flex-end;
		margin: 0 10px 10px 0;
	}
	
	.inventory_Wrapper .nodata {
		margin-top: 100px;
		text-align: center;
		color: #000;
	}
	
	.inventory_Wrapper .checkallbox {
		margin: 7px;
		padding-left: 5px;
		color: #606266;
		font-size: 14px;
		cursor: pointer;
	
	}

    .inventory_Wrapper .el-input--mini{
        font-size: 25px;
    }

    .inventory_Wrapper .el-input-number--mini{
        line-height: 37px;
        font-weight: bold;
    }

    .inventory_Wrapper .el-input__inner{
            height: 40px;
            font-weight: bold;
        }
	
	.inventory_Wrapper .checkallbox:hover {
		color: #409EFF;
	}
	
	.inventory_Wrapper .checkallbox-oop:hover {
		color: #409EFF;
	}
	
	.inventory_Wrapper .blank {
		color: #606266;
		text-decoration: none;
	}

    .inventory_Wrapper .vkhjkf{
        width:172px;
        font-weight: bold;
    }

    .inventory_Wrapper .warning-row {
        background-color: #bff5a1;
            font-size: 25px;
            color: #000;
            font-weight: bold;
        }
        
	.inventory_Wrapper .createOrder {
		display: flex;
		justify-content: flex-end;
		align-items: center;
		margin-top: 10px;
	}
	
	.inventory_Wrapper .createOrder-item {
		margin: 0 10px;
	}
	
	.inventory_Wrapper .el-dropdown-link {
		color: #606266 !important;
	}
	
	/* 	.loading-box{
		display: inline-block;
		height: 30px;
	} */
	
	.inventory_Wrapper .list-desc {
		display: flex;
		align-items: center;
		margin-left: 15px;
		border-bottom: 1px #eee solid;
	}

	.inventory_Wrapper .titl_desc_left{
		display: flex;
	}

	.inventory_Wrapper .titl_desc_right{
		display: flex;
		justify-content: flex-end;
		margin-top: 10px;
	}


	
	.inventory_Wrapper .chekbox {
		width: 30px;
		height: 30px;
		line-height: 30px;
	}
	
	.inventory_Wrapper .pic-box {
		display: flex;
		margin: 2px;
		width: 80px;
		height: 80px;
	}
	
	.inventory_Wrapper .return-item {
		display: flex;
		justify-content: space-between;
		box-sizing: border-box;
		padding: 10px;
		font-size: 14px;
	}
	
	.inventory_Wrapper .return-item-list {
		display: flex;
		align-items: center;
	
	}
	
	.inventory_Wrapper .unfold:nth-of-type(n+4) {
		display: none;
	
	}
	
	.inventory_Wrapper .pic-box-desc {
		width: 250px;
		margin-left: 20px;
	}
	
	.inventory_Wrapper .retrun-reasonr {
		margin-left: 30px;
	}
	
	.inventory_Wrapper .retrun-reasonr-btn {
		display: flex;
		flex-direction: column;
		align-items: center;
		margin-right: 20px;
	}
	
	.inventory_Wrapper .seller {
		margin-right: 10px;
		font-size: 18px;
	}
	
	.inventory_Wrapper .return-reasonr-desc {
		box-sizing: border-box;
		padding: 3px 0;
	}
	
	.inventory_Wrapper .seller-item {
		margin-left: 15px;
		font-size: 14px;
	}
	
	.inventory_Wrapper .seller-ppc {
		color: red;
	}
	
	.inventory_Wrapper .ppo_box{
		    /* display: flex;
			justify-content: space-between;
		    flex-wrap: wrap; */
			/* height: 40px; */
		    padding: 5px 10px;
		    margin: 0px -5px;
		    -webkit-box-align: center;
		    /* align-items: center; */
		    background: #000;
		    color: rgb(255, 255, 255);
		    border-top: 10px solid rgb(255, 255, 255);
		    border-bottom: 10px solid rgb(255, 255, 255);
		    border-radius: 2px;
	}
	
	.ppo-item{
		font-size: 20px;
		color: #fff;
		margin-right: 15px;
	}
	
	
	
	
	
	
	
	.ordersn-box {
		font-size: 12px;
	}
	
	.pic-wrapper {
		display: inline-block;
		width: 40px;
		height: 40px;
		margin-right: 5px;
		position: relative;
	}
	
	.pic-wrapper-quantity {
		position: absolute;
		top: 0;
		right: 0;
		display: inline-block;
		width: 15px;
		height: 15px;
		line-height: 15px;
		background-color: red;
		font-size: 8px;
		color: #fff;
		text-align: center;
	}
	
	.IdScaneArea .el-input__inner{
	width: 99%;
	height: 130px;
	font-size: 30px;
	
	}
	
	.flagbox{
		display: inline-block;
		width: 56px;
		height: 30px;
	}
	
	.flagbox .el-radio{
		    display: flex;
		    align-items: center;
	}
	
	.flagbox .el-radio__label{
		padding-left:5px!important;
	}
	
</style>
